// extracted by mini-css-extract-plugin
module.exports = {"articleItem":"ArticleItems_articleItem__PeY3F"};